import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Content = styled.div`
  position: relative;
`;

export const LabelFirstCLick = styled(TextLayoutComponent)`
  text-align: left;
  margin-bottom: 1em;
  color: ${(props) => props.theme.color.textSecondary};
`;
